module.exports = __webpack_public_path__ + "static/img/school.2f06649c.png";